import React, { useState, useEffect, useRef } from "react"
import { Link, navigate } from "gatsby"
import { observer } from "mobx-react-lite"

import styles from "./navbar.module.scss"
import { AuthService } from "services"
import UserStateStore from "state/UserStateStore"

export default observer(props => {
  const {
    className,
    style = {},
    searchBarProps = {},
    mode = "sticky",
    hideLeft = false,
    hideRight = false,
    scrollEffects = true,
    overlay = false,
    transparent = false,
    login = false,
    cta = true,
    isOnboarding
  } = props

  const ref = useRef()

  const [isScrolled, setScrolled] = useState(false)
  const [didScrollUp, setDidScrollUp] = useState(false)
  const [isStuck, setIsStuck] = useState(false)
  const [offset, setOffset] = useState(null)

  const handleLogout = () => {
    AuthService.doSignOut()
    navigate('/login')
  }

  function rightComponent() {
    if (AuthService.auth.currentUser) {
      if (!isOnboarding) {
         return <div className={styles.navLink}><Link to="/inbox">inbox</Link></div>
      }
      return <div className={styles.navLink}><div onClick={()=>handleLogout()}>Logout</div></div>
    } else {
      return (
        <div className={styles.container}>
          <div className={styles.navLink}>
            {isOnboarding && login ? (
              <Link to="/sign-up">Create an account</Link>
            ) : 
              <Link to="/login">Login</Link>
            }
          </div>
          {cta && !isOnboarding && (
            <div className={styles.navLink}>
              <Link
                to="/sign-up"
                className={[styles.actionButton, styles.bordered].join(" ")}
              >
                Sign Up<span>→</span>
              </Link>
            </div>
          )}
        </div>
      )
    }
  }

  function leftComponent() {
    const { leftComponent = true } = props
    if (leftComponent !== true) {
      return leftComponent
    }
    return (
      <div>
        <h1>
          <Link
            to="/"
            style={{
              color: `#FF0000`,
              fontFamily: "Avenir Next",
              fontStyle: "italic",
              textDecoration: `none`,
            }}
          >
            itty
          </Link>
        </h1>
      </div>
    )
  }
  return (
    <div
      ref={ref}
      style={style}
      className={[className, styles.wrapper, styles[mode]].join(" ")}
    >
      <div className={[styles.container, styles[mode]].join(" ")}>
        <div className={[styles.section, styles.left].join(" ")}>
          {leftComponent()}
        </div>
        <div className={[styles.section, styles.center].join(" ")}></div>
        <div className={[styles.section, styles.right].join(" ")}>
          {rightComponent()}
        </div>
      </div>
    </div>
  )
})
